import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { URI } from '../../../base/common/uri.js';
import { isObject } from '../../../base/common/types.js';
export var IBulkEditService = createDecorator('IWorkspaceEditService');

function isWorkspaceFileEdit(thing) {
  return isObject(thing) && (Boolean(thing.newUri) || Boolean(thing.oldUri));
}

function isWorkspaceTextEdit(thing) {
  return isObject(thing) && URI.isUri(thing.resource) && isObject(thing.edit);
}

export var ResourceEdit = /*#__PURE__*/function () {
  function ResourceEdit(metadata) {
    _classCallCheck(this, ResourceEdit);

    this.metadata = metadata;
  }

  _createClass(ResourceEdit, null, [{
    key: "convert",
    value: function convert(edit) {
      return edit.edits.map(function (edit) {
        if (isWorkspaceTextEdit(edit)) {
          return new ResourceTextEdit(edit.resource, edit.edit, edit.modelVersionId, edit.metadata);
        }

        if (isWorkspaceFileEdit(edit)) {
          return new ResourceFileEdit(edit.oldUri, edit.newUri, edit.options, edit.metadata);
        }

        throw new Error('Unsupported edit');
      });
    }
  }]);

  return ResourceEdit;
}();
export var ResourceTextEdit = /*#__PURE__*/function (_ResourceEdit) {
  _inherits(ResourceTextEdit, _ResourceEdit);

  var _super = _createSuper(ResourceTextEdit);

  function ResourceTextEdit(resource, textEdit, versionId, metadata) {
    var _this;

    _classCallCheck(this, ResourceTextEdit);

    _this = _super.call(this, metadata);
    _this.resource = resource;
    _this.textEdit = textEdit;
    _this.versionId = versionId;
    _this.metadata = metadata;
    return _this;
  }

  return ResourceTextEdit;
}(ResourceEdit);
export var ResourceFileEdit = /*#__PURE__*/function (_ResourceEdit2) {
  _inherits(ResourceFileEdit, _ResourceEdit2);

  var _super2 = _createSuper(ResourceFileEdit);

  function ResourceFileEdit(oldResource, newResource, options, metadata) {
    var _this2;

    _classCallCheck(this, ResourceFileEdit);

    _this2 = _super2.call(this, metadata);
    _this2.oldResource = oldResource;
    _this2.newResource = newResource;
    _this2.options = options;
    _this2.metadata = metadata;
    return _this2;
  }

  return ResourceFileEdit;
}(ResourceEdit);